module.exports = "/_next/static/videos/gpm-be97615f90a6356c2faa99643fa8026b.mp4";